import styled from 'styled-components'

export const Wrapper = styled.div``

export const SkeletonWrapper = styled.div`
  padding-top: 16px;
`
